import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from "react-router-dom";
  
export const ProfileComponent = () => {
  
   const history = useHistory();
   const profile = () =>{
        history.push('/profile');
    }
    return (
        <div className="text-align-center" onClick={profile}>
            <span className="font-size-smd bold font-family-default">
                Profile
            </span>
        </div>
    );
  };